import { Activity, SlidersHorizontal, UserRound, type LucideIcon } from "lucide-react";

/**
 * Shell-only pages (registered directly in main.tsx, not in routes.ts) that
 * still get a header tab of their own, like the design's "Profile" tab.
 */
export const SHELL_PAGE_META: Record<string, { labelKey: string; fallback: string; icon: LucideIcon }> = {
  profile: { labelKey: "shell.tabs.profile", fallback: "Profile", icon: UserRound },
  account: { labelKey: "shell.tabs.account", fallback: "Account", icon: UserRound },
  preferences: { labelKey: "shell.tabs.preferences", fallback: "Preferences", icon: SlidersHorizontal },
  "suite-status": { labelKey: "shell.tabs.suiteStatus", fallback: "System status", icon: Activity },
};
